import Image from 'src/components/image';
import styled from 'styled-components';
import dayjs from 'dayjs';

const EventCard = ({ item, index, onClick }) => {
  return (
    <EventCardWrapper href={item?.event_url || item?.link || '#'} target='_blank' rel='noopener noreferrer' onClick={() => onClick?.(item, index)}>
      <div className='event-card-thumb'>
        <Image image={item?.vertical_image || item?.image || ''} external={!!item?.vertical_image} title={item?.title} type={'CARD_MEDIUM'} />
      </div>

      <div className='event-card-content'>
        {(item?.event_start_date || item?.event_end_date) && (
          <p className='event-card-date'>
            {item?.event_start_date}
            {item?.event_start_date && item?.event_end_date ? ' - ' : ''}
            {item?.event_end_date && item.event_end_date}
          </p>
        )}
        {item?.title && <h3 className='event-card-title'>{item?.title}</h3>}
        {item?.event_location && (
          <p className='event-card-location'>
            <svg className='location-icon' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
              <path d='M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z' />
              <circle cx='12' cy='10' r='3' />
            </svg>
            <span className='location-text'>{item?.event_location}</span>
          </p>
        )}
      </div>
    </EventCardWrapper>
  );
};

export default EventCard;

const EventCardWrapper = styled.a`
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  .event-card-thumb {
    position: relative;
    width: 100%;
    padding-top: 140%;
    border-radius: 5px;
    overflow: hidden;
    background: #f0f0f0;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .event-card-content {
    padding: 8px 0;
  }

  .event-card-date {
    font-size: 18px;
    color: #e53935;
    margin: 0 0 4px;
    font-weight: 500;
  }

  .event-card-title {
    font-size: 24px;
    font-weight: 700;
    color: #222;
    margin: 0 0 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.2;
    min-height: 50px;
  }

  .event-card-location {
    font-size: 18px;
    color: #888;
    margin: 0;
    display: flex; /* flex สำหรับ icon + text */
    align-items: flex-start;
    gap: 4px;
    min-height: 38px;

    .location-icon {
      flex-shrink: 0;
      margin-top: 2px;
    }

    .location-text {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      line-height: 1.4;
    }
  }

  @media (max-width: 767px) {
    .event-card-thumb {
      padding-top: 130%;
    }

    .event-card-title {
      font-size: 22px;
      min-height: unset;
    }

    .event-card-date {
      font-size: 20px;
    }

    .event-card-location {
      font-size: 20px;
    }
  }
`;
